<template>
  <div>
  <modal ref="alarmModal" :title="modalTitle">
      <template #content>

        <NotificationHistory :selNode="selectedNode" :selNodeDesc="selectedNodeDescription"> </NotificationHistory>
      </template>
    </modal>
    <!-- Primer B-Card :: Opciones -->
    <!-- FAQ de USO REGLAS -->
    <div v-if="!acsPanel">
      <div class="bd-callout bd-callout-info bd-shadow p-0">
        <div class="ms-5 pt-4 ps-4">
          <input
            class="form-check-input"
            v-model="enabled"
            type="checkbox"
            name="enabled"
          />
          <label
            class="form-check-label ms-2"
            style="cursor: pointer"
            for="enabled"
            @click="saveNotificationSettings"
            ><span class="etiqueta" style="font-size: 0.9rem"
              >Activar el envío de alertas mediante email/sms cuando se produzcan.</span
            ></label
          >
        </div>
        <div class="ms-5 pt-3 ps-3">
          <small>
            <ul>
              <li>
                Se emitirá una alerta si no se reciben datos desde un dispositivo en las
                últimas

                <b-form-select
                  id="checkInterval"
                  name="checkInterval"
                  v-model="checkInterval"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="6">6h</b-form-select-option>
                  <b-form-select-option value="12">12h</b-form-select-option>
                  <b-form-select-option value="18">18h</b-form-select-option>
                  <b-form-select-option value="24">24h</b-form-select-option>
                  <b-form-select-option value="36">36h</b-form-select-option>
                  <b-form-select-option value="48">48h</b-form-select-option>
                  <b-form-select-option value="72">72h</b-form-select-option>
                </b-form-select>
                . Sólo se tendrán en cuenta aquellos que estén en el estado "Activo".
              </li>
            </ul>
          </small>
        </div>
      </div>

      <div class="bd-callout bd-callout-info bd-shadow p-0">
        <div class="ms-5 pe-5 pt-2 pb-2">
          <b-row>
            <!-- Columna 1-->
            <b-col>
              <div class="table-responsive mt-3">
                <table class="table table-hover">
                  <thead class="table-light">
                    <!-- Primera serie de columnas-->
                    <tr class="text-center">
                      <th>#</th>
                      <th>Direcciones email</th>
                      <th>Accion</th>
                    </tr>
                  </thead>

                  <tbody class="text-center">
                    <tr v-for="(item, index) in emailList" v-bind:key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item }}</td>
                      <td>
                        <button
                          class="btn-danger"
                          @click="deleteEmail(item)"
                          title="Eliminar"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>*</td>
                      <td>
                        <b-form-input
                          type="text"
                          v-model="appendEmail"
                          placeholder="Introduzca email"
                          id="appendEmail"
                          name="appendEmail"
                          size="sm"
                        />
                      </td>

                      <td>
                        <button
                          class="btn-primary"
                          @click="addEmail"
                          title="Agregar nuevo email"
                        >
                          <i class="fas fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
            <!-- Columna 2-->
            <b-col>
              <div class="table-responsive mt-3">
                <table class="table table-hover">
                  <thead class="table-light">
                    <!-- Primera serie de columnas-->
                    <tr class="text-center">
                      <th>#</th>
                      <th>Teléfonos</th>
                      <th>Accion</th>
                    </tr>
                  </thead>

                  <tbody class="text-center">
                    <tr v-for="(item, index) in numberList" v-bind:key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item }}</td>
                      <td>
                        <button
                          class="btn-danger"
                          @click="deleteNumber(item)"
                          title="Eliminar"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>*</td>
                      <td>
                        <b-form-input
                          type="text"
                          v-model="appendNumber"
                          placeholder="+34...."
                          id="appendNumber"
                          name="appendNumber"
                          size="sm"
                        />
                      </td>

                      <td>
                        <button
                          class="btn-primary"
                          @click="addNumber"
                          title="Agregar nuevo número de teléfono"
                        >
                          <i class="fas fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <!-- FAQ de USO REGLAS -->

    <!-- Segundo B-Card :: Listado -->
    <b-card>
      <p>Lista de alarmas recibidas</p>
      <hr style="height: 0.05rem" />
      <!-- Tabla con la lista de alarmas-->
      <b-card-text class="alarmsTable">
        <div>
          <vue-good-table
            :columns="acsPanel ? columnsAcs : encinaPanel ? columnsEncina : columns"
            :rows="rows"
            :search-options="{
              enabled: true,
              //trigger: 'enter',
              skipDiacritics: true,
              //searchFn: mySearchFn,
              placeholder: 'Buscar en la tabla',
              //externalQuery: searchQuery
            }"
            :sort-options="{
              enabled: true,
              initialSortBy: { field: 'sensor', type: 'asc' },
            }"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 10,
              dropdownAllowAll: false,
              //setCurrentPage: 2,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: 'Filas por pagina',
              ofLabel: 'de',
              pageLabel: 'pagina', // for 'pages' mode
              allLabel: 'Todas',
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span
                v-if="
                  props.column.field == 'acciones' || props.column.field == 'historico'
                "
              >
                <span
                  @click="discardNotification(props.row.id)"
                  v-if="props.row.status == 'Activa'"
                >
                  <i
                    class="fas fa-times-circle fa-lg fa-2x"
                    style="cursor: pointer"
                    title="Marcar como atendida"
                  ></i>
                  </span>
                  <span v-if="props.row.status!='activo' && props.column.field=='acciones'">-</span>
                  <span @click="showModal(props.row.id, props.row.sensor)" v-if="props.column.field == 'historico'">
                    <i
                      class="fas fa-eye fa-lg fa-2x"
                      style="cursor: pointer"
                      title="Ver Historico del sensor"
                    ></i>
                  </span>
                </span>
              </span>
            </template>
          </vue-good-table>
        </div>
      </b-card-text>
    </b-card>

  </div>
</template>

<script>
import Modal from "@/components/common/Modal";
import NotificationService from "@/services/NotificationService";
import { mapState, mapActions } from "vuex";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import MiscService from "@/services/MicService";
import NotificationHistory from "./NotificationHistory";

export default {
  name: "alarms-list",
  data() {
    return {
      enabled: false,
      emailList: [],
      numberList: [],
      appendEmail: "",
      appendNumber: "",
      checkInterval: 24,
      modalTitle: "",
      selectedNode: null,
      selectedNodeDescription : null,
      isModalVisible: false,
      acsPanel: null,
      encinaPanel: null,
      columns: [
        {
          label: "Fecha",
          thClass: "text-center",
          tdClass: "text-center",
          field: "createdAt",
        },
        {
          label: "Ubicación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "location",
        },
        {
          label: "UUID nodo",
          thClass: "text-center",
          tdClass: "text-center",
          field: "uuid",
        },
        {
          label: "Alias nodo",
          thClass: "text-center",
          tdClass: "text-center",
          field: "alias",
        },
        {
          label: "Motivo",
          thClass: "text-center",
          tdClass: "text-center",
          field: "message",
        },
        {
          label: "Estado",
          thClass: "text-center",
          tdClass: "text-center",
          field: "status",
        },
        {
          label: "Accion",
          thClass: "text-center",
          tdClass: "text-center",
          field: "acciones",
        },
        {
          label: "Historico",
          thClass: "text-center",
          tdClass: "text-center",
          field: "historico",
        },
        {
          label: "hiddenStatus",
          field: "hiddenStatus",
          hidden: true,
        },
        {
          label: "idnotification",
          field: "id",
          hidden: true,
        },
      ],
      columnsAcs: [
        {
          label: "Sensor",
          thClass: "text-center",
          tdClass: "text-center",
          field: "sensor",
        },
        {
          label: "Estado",
          thClass: "text-center",
          tdClass: "text-center",
          field: "status",
        },
        {
          label: "Fecha activación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaCreacion",
        },
        {
          label: "Fecha cancelación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaCancelacion",
        },
        {
          label: "Atendida por operario",
          thClass: "text-center",
          tdClass: "text-center",
          field: "atendida",
        },
        {
          label: "Fecha atendida",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaAtendida",
        },
        {
          label: "Atender alarma",
          thClass: "text-center",
          tdClass: "text-center",
          field: "acciones",
        },
        {
          label: "Historico",
          thClass: "text-center",
          tdClass: "text-center",
          field: "historico",
        },
        {
          label: "idAlarm",
          field: "id",
          hidden: true,
        },
      ],
      columnsEncina: [
        {
          label: "Sensor",
          thClass: "text-center",
          tdClass: "text-center",
          field: "sensor",
        },
        {
          label: "Tipo",
          thClass: "text-center",
          tdClass: "text-center",
          field: "type",
        },
        {
          label: "Estado",
          thClass: "text-center",
          tdClass: "text-center",
          field: "status",
        },
        {
          label: "Fecha activación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaCreacion",
        },
        {
          label: "Fecha cancelación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaCancelacion",
        },
        {
          label: "Atendida por operario",
          thClass: "text-center",
          tdClass: "text-center",
          field: "atendida",
        },
        {
          label: "Fecha atendida",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaAtendida",
        },
        {
          label: "Atender alarma",
          thClass: "text-center",
          tdClass: "text-center",
          field: "acciones",
        },
        {
          label: "Historico",
          field: "historico",
          hidden: true,
        },
        {
          label: "idAlarm",
          field: "idAlarm",
          hidden: true,
        },
      ],
      rows: [],
    };
  },
  components: {
    VueGoodTable,
    modal: Modal,
    NotificationHistory : NotificationHistory,

  },
  computed: {
    ...mapState("notification", ["v_notificationList"]),
  },
  watch: {
    v_notificationList: function (newVal, oldVal) {
      if (newVal != null) {
        this.populateRows();
      }
    },
    checkInterval: function (newVal, oldVal) {
      if (newVal != null) {
        this.updateNotificationSettings();
      }
    },
  },
  methods: {
    ...mapActions("notification", ["v_getLastNotificationList"]),
    // Actualizar las NotificationSettings
    async saveNotificationSettings() {
      // Toggle checkbox
      this.enabled = !this.enabled;
      this.updateNotificationSettings();
    },

    showModal(idnodo, description) {
      //Ver si hay que poner el modal en modo edición o como nuevo psando el ID
      this.modalTitle =`Historico de alarma del nodo "${description}"`;
      this.selectedNode = idnodo;
      this.selectedNodeDescription = description;
      this.$refs.alarmModal.show();
    },

    async updateNotificationSettings() {
      //datastruct
      let dataToUpdate = {
        enabled: this.enabled,
        checkInterval: this.checkInterval,
        emailList: this.emailList,
        smsList: this.numberList,
      };

      await NotificationService.updateNotificationSettings(dataToUpdate)
        .then((response) => {
          // Message
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: "Cambios guardados",
            text: "Se han guardado los cambios correctamente",
            duration: 3000,
            speed: 1000,
          });
        })
        .catch((err) => {
          console.log("Error actualizando las opciones de notificacion");
          console.log(err);
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error guardando cambios",
            text:
              "Ha ocurrido un error guardando los cambios en el sistema de notificaciones",
            duration: 3000,
            speed: 1000,
          });
        });
    },

    discardNotification(id) {
      NotificationService.discardNotification(id)
        .then((response) => {
          // Forzar refrescar lista
          this.v_getLastNotificationList();
          // Message
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: "Notificación atendida",
            text: response.message,
            duration: 3000,
            speed: 1000,
          });
        })
        .catch((err) => {
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error modificación la notificación",
            text: "Ha ocurrido un error al marcar la notificación como atendida.",
            duration: 3000,
            speed: 1000,
          });
        });
    },

    async deleteEmail(email) {
      var index = this.emailList.indexOf(email);
      if (index !== -1) {
        this.emailList.splice(index, 1);
      }
      await this.updateNotificationSettings();
    },

    async deleteNumber(number) {
      var index = this.numberList.indexOf(number);
      if (index !== -1) {
        this.numberList.splice(index, 1);
      }
      await this.updateNotificationSettings();
    },

    async addNumber() {
      if (this.appendNumber != "") {
        this.numberList.push(this.appendNumber);
        await this.updateNotificationSettings();
        this.appendNumber = "";
      }
    },

    async addEmail() {
      if (this.appendEmail != "") {
        this.emailList.push(this.appendEmail);
        await this.updateNotificationSettings();
        this.appendEmail = "";
      }
    },

    // Rellenar las filas
    populateRows() {
      // Clean array before populate it
      this.rows = [];

      // Fill the array
      for (let i = 0; i < this.v_notificationList.length; i++) {
        //Fill the struct
        let newData = {};
        if (this.acsPanel) {
          newData = {
            sensor: this.v_notificationList[i].sensor
              ? this.v_notificationList[i].sensor.description
              : "Sin sensor asociado",
            status: this.v_notificationList[i].estado,
            fechaCreacion: this.$moment(String(this.v_notificationList[i].ts_activa))
              .local()
              .format("DD-MM-YYYY HH:mm:ss"),
            fechaCancelacion: this.v_notificationList[i].ts_fin
              ? this.$moment(String(this.v_notificationList[i].ts_fin))
                  .local()
                  .format("DD-MM-YYYY HH:mm:ss")
              : "-",
            atendida: this.v_notificationList[i].atendida ? "Sí" : "No",
            fechaAtendida: this.v_notificationList[i].ts_atendida
              ? this.$moment(String(this.v_notificationList[i].ts_atendida))
                  .local()
                  .format("DD-MM-YYYY HH:mm:ss")
              : "-",
            id: this.v_notificationList[i]._id,
            /*Be carefull -> inverted quote to multiple html lines -> Now as slot*/
            /*acciones: ''*/
          };
        } else if (this.encinaPanel) {
          newData = {
            sensor: this.v_notificationList[i].sensor
              ? this.v_notificationList[i].sensor.description
              : "Sin sensor asociado",
            type: this.v_notificationList[i].type,
            status: this.v_notificationList[i].estado,
            fechaCreacion: this.$moment(String(this.v_notificationList[i].ts_activa))
              .local()
              .format("DD-MM-YYYY HH:mm:ss"),
            fechaCancelacion: this.v_notificationList[i].ts_fin
              ? this.$moment(String(this.v_notificationList[i].ts_fin))
                  .local()
                  .format("DD-MM-YYYY HH:mm:ss")
              : "-",
            atendida: this.v_notificationList[i].atendida ? "Sí" : "No",
            fechaAtendida: this.v_notificationList[i].ts_atendida
              ? this.$moment(String(this.v_notificationList[i].ts_atendida))
                  .local()
                  .format("DD-MM-YYYY HH:mm:ss")
              : "-",
            id: this.v_notificationList[i]._id,
            /*Be carefull -> inverted quote to multiple html lines -> Now as slot*/
            /*acciones: ''*/
          };
        } else {
          newData = {
            id: this.v_notificationList[i]._id,
            createdAt: this.v_notificationList[i].createdAt
              ? this.$moment(String(this.v_notificationList[i].createdAt)).format(
                  "DD/MM/YYYY HH:mm:ss"
                )
              : "-",
            uuid:
              this.v_notificationList[i].device && this.v_notificationList[i].device.uuid
                ? this.v_notificationList[i].device.uuid
                : "-",
            alias:
              this.v_notificationList[i].device && this.v_notificationList[i].device.alias
                ? this.v_notificationList[i].device.alias
                : "-",
            message: this.v_notificationList[i].message
              ? this.v_notificationList[i].message
              : "-",
            status: this.v_notificationList[i].estado
              ? this.v_notificationList[i].estado
              : "-",
            location:
              this.v_notificationList[i].device &&
              this.v_notificationList[i].device.location
                ? this.v_notificationList[i].device.location_ref.alias
                : "-",
          };
        }
        //Push the data to the array
        this.rows.push(newData);
      }
    },
  },
  async mounted() {
    let response = await MiscService.getAcronym();
    let acronimo = response.data.data.acronym
      ? response.data.data.acronym
      : process.env.VUE_APP_PROJECT_ACRONYM;
    this.acsPanel = acronimo == "acs";
    this.encinaPanel = acronimo == "encina";
    console.log(`encinaPanel: ${this.encinaPanel}`);

    // Pedit la configuraicon de las Settings al iniciar el componente
    NotificationService.getNotificationSettings()
      .then((response) => {
        if (response.data) {
          this.emailList = response.data.emailList;
          this.numberList = response.data.smsList;
          this.enabled = response.data.enabled;
          this.checkInterval = response.data.checkInterval
            ? response.data.checkInterval
            : 24;
        }
      })
      .catch((err) => {
        console.log("Error actualizando las opciones de notificacion");
        console.log(err);
        this.$notify({
          group: "notificateDiv",
          type: "error",
          title: "Error guardando cambios",
          text:
            "Ha ocurrido un error guardando los cambios en el sistema de notificaciones",
          duration: 3000,
          speed: 1000,
        });
      });

    // En caso de que sea la primera vez que se carga el componente y no se ha detectado
    // el trigger por reactividad, cargamos los datos iniciales
    if (this.rows.length == 0) {
      this.v_getLastNotificationList();
      this.populateRows();
    }
  },
};
</script>

<style scoped>
/* Estilo de la tabla */
table {
  border: 1px solid #dfe6ec;
}
table th {
  font-size: 0.77rem;
  border-right: 1px solid #dfe6ec;
}

table td {
  font-size: 0.77rem;
  border-right: 1px solid #dfe6ec;
}
.table th {
  padding: 0.3rem;
}

.table td {
  padding: 0.2rem;
}
/* COPIADO DE LA PAGINA DE BOOTSTRAP*/
.bd-callout {
  padding: 1rem;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  border: 1px solid #e9ecef;
  border-left-width: 0.25rem;
  border-radius: 0.25rem;
  background: #fff;
}

.bd-callout-info {
  border-left-color: #5bc0de;
}

.bd-callout-warning {
  border-left-color: #f0ad4e;
}

.bd-callout-danger {
  border-left-color: #d9534f;
}

.bd-shadow {
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
  transition: 0.3s;
}

.btn-primary {
  background-color: #83adeb;
  border-color: transparent;
  border-radius: 0.4rem;
  padding-bottom: 3px;
}

.btn-primary:hover {
  background-color: #4c88e4;
}

.btn-danger {
  background-color: #e45d86;
  border-color: transparent;
  border-radius: 0.4rem;
  padding-bottom: 3px;
  padding-top: 2px;
}

.btn-danger:hover {
  background-color: #e61e5a;
}

.custom-select {
  width: auto;
  zoom: 0.8;
}
</style>
